import React from 'react'
const Controls: React.FC<{ children: JSX.Element[] | JSX.Element }> = ({
  children,
}) => {
  return <div>{children}</div>
}
export default Controls
